import { Injectable } from "@angular/core";
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { KYMW1300Model } from '../kymw1300.model';
import { PlessRequest } from "src/app/shared/vo/pless-request.model";

/**
 * 商品企画マスタ画面　特集コード一覧を取得するサービス
 *
 * @export GetFeatureCodeListService
 * @class GetFeatureCodeListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetFeatureCodeListService extends PlessJsonResponderSub<any> {

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetFeatureCodeListService
   */
  private successFunc: (model: any) => void;

  /**
   * 処理に使用するVO
   *
   * @private
   * @type {Object}
   */
  private vo: {
    orderCode: '',
    mediumType: '',
  };

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetFeatureCodeListService
   */
  // private getBody(): PlessRequest {
  //   return new PlessRequest();
  // }
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.orderCode,
        MediumType: this.vo.mediumType,
      }
    });
  }


  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetFeatureCodeListService
   */
  execute( vo: any, successFunc: (model: any) => void): void {
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('KYMW13GetFeatureCodeList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetFeatureCodeListService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
